import { BasketLine } from '@models/api-orders.models';

export const setGiftOptions = (
    line: BasketLine,
    giftWrappingId?: string,
    giftCardId?: string,
    giftCardText?: string
): BasketLine => {
    const giftOptions: Partial<Pick<BasketLine, 'giftWrappings' | 'giftWrappingsCard' | 'giftWrappingsCardText'>> = {};
    if (giftWrappingId) {
        giftOptions.giftWrappings = [giftWrappingId];
    }

    if (giftCardId) {
        giftOptions.giftWrappingsCard = giftCardId;
        giftOptions.giftWrappingsCardText = giftCardText || '';
    }

    return { ...line, ...giftOptions };
};
